import { createAsyncThunk } from '@reduxjs/toolkit';
import { setError, setGlobalLoading } from '../../../redux/slice';
import * as api from '../api';
import Cookies from 'js-cookie';
import { TOKEN_NAME } from '../../../constants';
import jwtDecode from 'jwt-decode';
import { sendUserActivityEvent } from '../../../utils/useractivity';

export const doSignIn = createAsyncThunk('auth/doSignIn', async (params, thunkAPI) => {
  try {
    thunkAPI.dispatch(setGlobalLoading(true));
    const { response, error } = await api.signIn(params);
    const token = response?.access_token;

    if (token) {
      const { exp } = jwtDecode(token);
      Cookies.set(TOKEN_NAME, token, { expires: new Date(exp * 1000) });
      await thunkAPI.dispatch(doGetProfile());

      // Get user from state
      const state = thunkAPI.getState();
      const user = state.auth.user;

      // Emit event with user ID after successful sign-in
      if (user && user.id) {
        sendUserActivityEvent({
          userId: user.id,
          eventType: 'login',
          pageUrl: window.location.href,
        });
      }
    }
    thunkAPI.dispatch(setGlobalLoading(false));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doResetPassword = createAsyncThunk('auth/doResetPassword', async (params, thunkAPI) => {
  try {
    thunkAPI.dispatch(setGlobalLoading(true));
    const { response, error } = await api.resetPassword(params);
    thunkAPI.dispatch(setGlobalLoading(false));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGetImpersonables = createAsyncThunk('auth/doGetImpersonables', async (params, thunkAPI) => {
  try {
    thunkAPI.dispatch(setGlobalLoading(true));
    const { response, error } = await api.getImpersonables();
    thunkAPI.dispatch(setGlobalLoading(false));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doImpersonateUser = createAsyncThunk('auth/doImpersonateUser', async (params, thunkAPI) => {
  try {
    thunkAPI.dispatch(setGlobalLoading(true));
    const { response, error } = await api.impersonate(params);
    thunkAPI.dispatch(setGlobalLoading(false));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doResetImpersonation = createAsyncThunk('auth/doResetImpersonation', async (params, thunkAPI) => {
  try {
    thunkAPI.dispatch(setGlobalLoading(true));
    await api.resetImpersonation();
    const { response, error } = await api.getProfile();

    thunkAPI.dispatch(setGlobalLoading(false));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doForgotPassword = createAsyncThunk('auth/doForgotPassword', async (params, thunkAPI) => {
  try {
    thunkAPI.dispatch(setGlobalLoading(true));
    const { response, error } = await api.forgotPassword(params);
    thunkAPI.dispatch(setGlobalLoading(false));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGetProfile = createAsyncThunk('auth/doGetProfile', async (params, thunkAPI) => {
  try {
    const { response, error } = await api.getProfile(params);
    if (error) {
      thunkAPI.dispatch(setError(error));
      return thunkAPI.rejectWithValue(error);
    } else {
      return response;
    }
    // return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});
